import React, { Component, Fragment } from 'react'
import { observable, makeObservable } from 'mobx'
import { observer } from 'mobx-react'
import '../../../assets/css/adminbox.css'
import i18n from 'i18next'

@observer
export default class AdminBox extends Component {
    @observable showAdminBox = false

    constructor(props) {
        super(props)
        makeObservable(this)
    }

    toggleAdminBox = () => {
        this.showAdminBox = !this.showAdminBox
    }

    dataViewerSurveyLink = (surveyId) => {
        const { store } = this.props
        return store.getDataviewerLink({
            schema: 'explori_v3',
            table: 'survey',
            column: 'surveyId',
            operator: 'eq',
            value: surveyId,
        })
    }

    dataViewerSurveyPageQuestionLink = (surveyId) => {
        const { store } = this.props
        return store.getDataviewerLink({
            schema: 'explori_v3',
            table: 'survey_page_question',
            column: 'surveyId',
            operator: 'eq',
            value: surveyId,
        })
    }

    dataViewerSurveyDataLink = (clientId, surveyId) => {
        const { store } = this.props
        return store.getDataviewerLink({
            schema: `explori_v3_clientid_${clientId}`,
            table: 'surveydata',
            column: 'surveyId',
            operator: 'eq',
            value: surveyId,
        })
    }

    dataViewerSurveyUserLink = (clientId, surveyId) => {
        const { store } = this.props
        return store.getDataviewerLink({
            schema: `explori_v3_clientid_${clientId}`,
            table: 'surveyuser',
            column: 'surveyId',
            operator: 'eq',
            value: surveyId,
        })
    }

    dataViewerSurveyEmailScheduleLink = (surveyId) => {
        const { store } = this.props
        return store.getDataviewerLink({
            schema: 'explori_v3',
            table: 'surveyemailschedule',
            column: 'surveyId',
            operator: 'eq',
            value: surveyId,
        })
    }

    render() {
        const { store, survey } = this.props
        const surveyId = survey.id
        const { clientId } = store.tokenData
        return (
            <Fragment>
                { store.showAdminBox && (
                    <div id="adminbox_survey" className="adminbox">
                        <span>
                            <a target="_blank" href={`/intranet/surveyDataIntegrityCheck?surveyId=${surveyId}`} rel="noreferrer">{i18n.t('adminBox.integrity')}</a>
                        </span>
                        <span>
                            <a target="_blank" href={`/intranet/traffic?surveyId=${surveyId}`} rel="noreferrer">{i18n.t('adminBox.traffic')}</a>
                        </span>
                        <span>
                            <a target="_blank" href={`/intranet/surveyBranching?surveyId=${surveyId}`} rel="noreferrer">{i18n.t('adminBox.branching')}</a>
                        </span>
                        {store.showIds && (
                            <span id="hideshowdebugging" onClick={store.toggleShowIds}>{i18n.t('adminBox.hide')}</span>
                        )}
                        {!store.showIds && (
                            <span id="hideshowdebugging" onClick={store.toggleShowIds}>{i18n.t('adminBox.show')}</span>
                        )}
                        <div id="dataviewer_links">
                            <span>
                                <a target="_blank" href={this.dataViewerSurveyLink(surveyId)} rel="noreferrer">{i18n.t('adminBox.survey')}</a>
                            </span>
                            <span>
                                <a target="_blank" href={this.dataViewerSurveyPageQuestionLink(surveyId)} rel="noreferrer">{i18n.t('adminBox.surveyPage')}</a>
                            </span>
                            <span>
                                <a target="_blank" href={this.dataViewerSurveyDataLink(clientId, surveyId)} rel="noreferrer">{i18n.t('adminBox.clientData')}</a>
                            </span>
                            <span>
                                <a target="_blank" href={this.dataViewerSurveyUserLink(clientId, surveyId)} rel="noreferrer">{i18n.t('adminBox.surveyUser')}</a>
                            </span>
                            <span>
                                <a target="_blank" href={this.dataViewerSurveyEmailScheduleLink(surveyId)} rel="noreferrer">{i18n.t('adminBox.emailSchedule')}</a>
                            </span>
                        </div>
                    </div>
                )}
            </Fragment>
        )
    }
}
